import React from 'react';
import {
  Typography,
  Box,
} from '@mui/material';

const PageHeader = ({ title, subtitle, icon: Icon, titleAdornment = null }) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        {Icon && <Icon sx={{ mr: 2, fontSize: { xs: 30, sm: 34, md: 36 }, color: 'primary.main' }} />}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, flexWrap: 'wrap' }}>
          <Typography
            variant="h4"
            component="h1"
            sx={{ fontSize: { xs: '1.4rem', sm: '1.6rem', md: '1.85rem', lg: '2rem', xl: '2.1rem' }, fontWeight: 700 }}
          >
            {title}
          </Typography>
          {titleAdornment}
        </Box>
      </Box>
      {subtitle && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontSize: { xs: '0.8rem', sm: '0.85rem', md: '0.95rem', lg: '1rem' } }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default PageHeader;
